<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText30.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText31.png"
        />
        <div class="solutionDetailText">
          北斗院提供智慧园区解决方案，积累了丰富的物流园区、校园、政府机关等行业经验。基于先进的物联网、人工智能、大数据等技术手段，以建设数字化、智能化、绿色化的园区为目标，通过对园区内各类设施和资源进行全面感知、智能管理和优化调度，实现降本增效，助力园区发展迈上新台阶。
        </div>
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">天穹智慧园区管理系统</div>
            <div class="solutionDetailSecondText">
              覆盖工业园区、校园、政府机关等各类园区。包含访客管理、门禁管理、环境监测、能源管理、安全管理、运营管理、服务管理等模块，实现对园区内环境、能源、安防、各类设施、人员等进行智能化管理，以提升园区内各类设施和资源的全面感知，实现园区管理更安全、更便捷、更高效。</div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic29.png"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic32.png"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">海信智慧物流园管理系统</div>
            <div class="solutionDetailSecondText">
              整合园区各企业业务系统，实现原材料与成品出入库业务的无缝集成；支持原材料JIT车辆到车计划编排；实现车辆装卸效率考核；集成移动互联技术，为业务伙伴实现入园自动化、装卸排队通知智能化，自动调度车辆上月台；记录园区作业全周期内关键节点数据。通过智能园区平台，实现访客在线预约、信鸿审批，门闸集成访客车辆信息自动放行；自动引导访客路线，实时监控园区全区车辆在园状态。通过打造海信智慧物流园区标杆，数字化赋能海信园区发展，提升海信园区智能管理水平，试点成熟后推广到全集团。
            </div>
          </div>
        </div>

      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail8.vue